import api from '@api/api';
import IHttpResponse from '@api/http-response';
import IPermissionCategory from '@typing/permission-category';

export const getAllByCategory = (): Promise<IHttpResponse<IPermissionCategory[]>> => {

  return api.get('/api/_permission-category');

};
